module.exports = ".amd-dialog__content .amd-card-bg-color,\n.amd-dialog__content .amd-card {\n  background-color: white;\n  text-align: center; }\n"